import { DEFAULT_SERVER_PATH } from "src/constant";

export default function formatReportPath(path = DEFAULT_REPORT_PATH) {
  let retPath = path;
  const protocol = location.protocol;
  // 不包含斜杠"/"，判断为域名配置，进行默认补全逻辑
  if (!/\//.test(retPath)) {
    retPath = `https://${retPath}${DEFAULT_SERVER_PATH}`
  }
  // 双斜杠开头的配置，补全协议头
  if(/^\/\/[^\/]/.test(retPath)) {
    retPath = protocol + retPath;
  }
  // 单斜杠开头的配置，补全协议与域名
  if (/^\/[^\/]/.test(retPath)) {
    retPath = `${location.origin}${retPath}`;
  }
  if(!/^(https?:)?\/\//.test(retPath)) {
    retPath = `${protocol}//${retPath}`;
  }
  // 非斜杠结尾，添补斜杠结束
  if(!/\/$/.test(retPath)) {
    retPath = retPath + '/';
  }
  return retPath;
}
